import aprovadoresRotas from './aprovadores/AprovadoresRotas'
import financeiroRotas from './financeiro/FinanceiroRotas'
import conveniosRotas from './convenios/ConveniosRotas'
import gestoresRotas from './gestores/GestoresRotas'
import gerentesRotas from './gerentes/GerentesRotas'
import cronogramasRotas from './cronogramas/CronogramasRotas'

export default {
    path: 'gescon',
    name: 'Gescon',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [aprovadoresRotas, financeiroRotas, conveniosRotas, gestoresRotas, gerentesRotas, cronogramasRotas]
}
